export default function SensorControl() {
    return(
        <div>Sensors</div>
    )
};
